import { IState } from '../../store';

export const selectIsPhoneWarningOpen = (state: IState): boolean => {
  return state.phoneWarning.isOpen;
};
